// authService.js
import { jwtDecode } from "jwt-decode";
import { getAccessToken, isTokenValid, refreshAccessToken } from "./tokenService";

export default {
  data: {
    isAuthenticated: false,
    userRole: null  // Add a new data property for the user's role
  },
  login() {
    this.data.isAuthenticated = true;
  },
  logout() {
    this.data.isAuthenticated = false;
    this.data.userRole = null;  // Reset the user's role when they log out
  },
  async checkAuth() {
    // Validate the JWT locally (no network call per navigation). If the access token is
    // expired, transparently refresh it using the HttpOnly refresh cookie before giving up.
    let token = getAccessToken();
    if (!isTokenValid(token)) {
      token = await refreshAccessToken();
    }

    if (token) {
      try {
        this.data.userRole = jwtDecode(token).role;
        this.login();
        return true;
      } catch {
        this.logout();
        return false;
      }
    }

    this.logout();
    return false;
  },
  getUserRole() {  // Add a new method to get the user's role
    return this.data.userRole;
  }
};
